<section class="info-card" aria-labelledby="request-status-title">
  <div class="info-card__header flex align-center gap-8">
    <app-icon
      class="info-card__icon"
      name="flag"
      size="sm"
      color="custom"
      customColor="currentColor"
      role="presentation"
    ></app-icon>
    <h2 id="request-status-title" class="info-card__title">Request Status</h2>
  </div>

  <div class="info-card__body status-card__body flex flex-col">
    <p class="status-card__hint">
      Select the current staff status. Changes are saved to the request and shown on the dashboard.
    </p>

    <div
      class="status-card__options flex flex-col"
      role="radiogroup"
      aria-label="Staff-selectable request statuses"
      [attr.aria-describedby]="showSelectionError() ? 'status-selection-error' : null"
    >
      @for (option of statusOptions; track option.status) {
      <button
        type="button"
        role="radio"
        class="status-option flex align-center gap-8"
        [class.status-option--selected]="isStatusSelected(option.status)"
        [attr.aria-checked]="isStatusSelected(option.status)"
        [attr.tabindex]="optionTabIndex($index)"
        (click)="selectStatus(option.status)"
        (keydown)="onOptionKeydown($event, $index)"
      >
        <span [class]="'badge status-option__label ' + option.badgeClass">
          {{ option.label }}
        </span>
        <span class="status-option__description">{{ option.description }}</span>
        @if (isStatusSelected(option.status)) {
        <app-icon
          class="status-option__check"
          name="check_circle"
          size="xs"
          color="custom"
          customColor="currentColor"
          role="presentation"
        ></app-icon>
        }
      </button>
      }
    </div>

    @if (showSelectionError()) {
    <p id="status-selection-error" class="status-card__error flex align-center gap-8" role="alert">
      <app-icon
        name="info"
        size="xs"
        color="custom"
        customColor="currentColor"
        role="presentation"
      ></app-icon>
      <span>Select a status before updating.</span>
    </p>
    } @if (saveError()) {
    <p class="status-card__error flex align-center gap-8" role="alert">
      <app-icon
        name="info"
        size="xs"
        color="custom"
        customColor="currentColor"
        role="presentation"
      ></app-icon>
      <span>{{ saveError() }}</span>
    </p>
    }

    <button
      type="button"
      class="primary-button status-card__update fw-600"
      [class.status-card__update--saved]="justSaved()"
      (click)="updateStatus()"
      [disabled]="isSaving()"
    >
      @if (isSaving()) {
      <span class="status-card__spinner" aria-hidden="true"></span>
      <span>Saving…</span>
      } @else if (justSaved()) {
      <app-icon
        name="check_circle"
        size="xs"
        color="custom"
        customColor="currentColor"
        role="presentation"
      ></app-icon>
      <span>Saved</span>
      } @else {
      <app-icon
        name="sync"
        size="xs"
        color="custom"
        customColor="currentColor"
        role="presentation"
      ></app-icon>
      <span>Update Status</span>
      }
    </button>

    <div class="status-card__system flex flex-col">
      <h3 class="status-card__system-title">System-set statuses</h3>
      <div class="status-card__system-row flex gap-8">
        <span class="badge badge--new">New</span>
        <span class="status-card__system-text"
          >Auto-applied before any staff activity on the request.</span
        >
      </div>
      <div class="status-card__system-row flex gap-8">
        <span class="badge badge--overdue">Overdue</span>
        <span class="status-card__system-text"
          >Auto-applied when the request is 7+ days old and shown with the request on the
          dashboard.</span
        >
      </div>
    </div>
  </div>
</section>
